export default __webpack_public_path__ + "static/media/icon-search.fc3d1c8f.svg";